import React from 'react';

const SMTPIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M14.9886 19.753L19.2194 15.5019L23.4503 36.7577L19.2194 41.0089L14.9886 19.753Z"
        fill="#C5D0DB"
      />
      <rect
        width="5.99773"
        height="23.1341"
        transform="matrix(0.705413 -0.708796 0.705413 0.708796 3 24.7119)"
        fill="#A0ABB8"
      />
      <path
        d="M23.4501 11.2511L27.681 6.99992L31.9119 28.2558L27.681 32.5069L23.4501 11.2511Z"
        fill="#C5D0DB"
      />
      <rect
        width="5.99773"
        height="23.1341"
        transform="matrix(0.705413 -0.708796 0.705413 0.708796 23.45 11.251)"
        fill="#A0ABB8"
      />
      <rect
        width="5.99773"
        height="17.9932"
        transform="matrix(0.705413 -0.708796 0.705413 0.708796 14.9883 19.7534)"
        fill="#A0ABB8"
      />
    </svg>
  );
};

export default SMTPIcon;
